// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand_brand__SvLWJ","logo":"Brand_logo__1KriI","tagline":"Brand_tagline__3ruMl","invert":"Brand_invert__2CW7P"};